module.exports = __webpack_public_path__ + "static/media/up-arrow.a0ef0d2c.svg";